export const CHECKOUT_URL =
  'https://sistema-electricista-domiciliario-desde-cero.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

export const BRAND = 'CM DIGITAL PRO'
export const PRODUCT = 'SISTEMA ELECTRICISTA DOMICILIARIO DESDE CERO'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/cxTZsw3f7vZ5GbsFvDs7HG/Imagen_de_Codex_4_sept_2026,_16_45_32.png'

export const ROUTE = [
  'Fundamentos',
  'Herramientas',
  'Instalaciones',
  'Circuitos',
  'Mediciones',
  'Diagnóstico',
]

export const questions = [
  '¿Por dónde empiezo?',
  '¿Qué significa fase, neutro, tensión o resistencia?',
  '¿Qué herramienta sirve para cada tarea?',
  '¿Cómo interpreto un circuito?',
  '¿Cómo se utiliza un multímetro?',
  '¿Cómo puedo analizar una falla sin limitarme a adivinar?',
]

export const goals = [
  'Comprender tensión, corriente, resistencia, potencia y Ley de Ohm.',
  'Reconocer herramientas, materiales y componentes eléctricos comunes.',
  'Entender cómo se organiza conceptualmente una instalación domiciliaria.',
  'Interpretar esquemas básicos de iluminación, interruptores y tomacorrientes.',
  'Comprender mediciones de tensión, resistencia y continuidad con multímetro.',
  'Analizar síntomas eléctricos mediante hipótesis y evidencia.',
  'Reconocer cuándo una situación está fuera de tu nivel y requiere un profesional habilitado.',
]

export const systemFeatures = [
  'Explicaciones fáciles de seguir',
  'Diagramas y esquemas',
  'Ejemplos visuales',
  'Ejercicios educativos',
  'Casos de diagnóstico',
  'Checklists y recursos prácticos',
]

export const tomos = [
  {
    title: 'TOMO 1 — FUNDAMENTOS DE ELECTRICIDAD Y SEGURIDAD™',
    desc: 'Comprende tensión, corriente, resistencia, potencia, energía, corriente alterna y continua, Ley de Ohm, circuitos, cortocircuitos, sobrecargas, fugas, fase, neutro y conductor de protección.',
    extraDesc:
      'Además, aprende los principios de seguridad que debes conocer antes de continuar.',
    tag: 'Comprende las bases. Respeta la electricidad. Avanza con seguridad.',
  },
  {
    title: 'TOMO 2 — HERRAMIENTAS, MATERIALES Y COMPONENTES™',
    desc: 'Aprende a reconocer herramientas, conductores, cables, cajas, canalizaciones, conectores, interruptores, tomacorrientes, luminarias y otros componentes habituales.',
    extraDesc:
      'Descubre para qué sirven y qué características debes observar para comprender mejor su utilización.',
    tag: 'Reconoce. Comprende. Organiza.',
  },
  {
    title: 'TOMO 3 — ANATOMÍA DE UNA INSTALACIÓN DOMICILIARIA™',
    desc: 'Comprende el recorrido conceptual de la electricidad dentro de una vivienda y la relación entre alimentación, tablero, protecciones, puesta a tierra y circuitos.',
    extraDesc:
      'Aprende también símbolos eléctricos y lectura inicial de planos.',
    tag: 'Observa el sistema. Entiende el recorrido. Conecta los conceptos.',
  },
  {
    title: 'TOMO 4 — ILUMINACIÓN, INTERRUPTORES Y TOMACORRIENTES™',
    desc: 'Descubre la lógica detrás de los circuitos domiciliarios más comunes mediante representaciones visuales, diagramas y ejemplos educativos.',
    extraDesc:
      'Aprende a interpretar cómo se relacionan los diferentes componentes.',
    tag: 'Observa. Interpreta. Comprende.',
  },
  {
    title: 'TOMO 5 — MEDICIONES Y MULTÍMETRO™',
    desc: 'Comprende cómo funciona el multímetro y los principios de medición de tensión, resistencia y continuidad mediante prácticas educativas seguras.',
    extraDesc:
      'Aprende a interpretar resultados y a utilizar una medición como evidencia.',
    tag: 'Mide. Interpreta. Comprueba.',
  },
  {
    title: 'TOMO 6 — DIAGNÓSTICO DE FALLAS Y MÉTODO PROFESIONAL™',
    desc: 'Aprende a analizar problemas utilizando una secuencia lógica: SÍNTOMA → RIESGO → INFORMACIÓN → HIPÓTESIS → EVIDENCIA → DECISIÓN.',
    extraDesc:
      'Trabaja con casos ficticios para desarrollar criterio y evitar uno de los errores más comunes del principiante: confundir una sospecha con un diagnóstico.',
    tag: 'Observa. Analiza. Comprueba. Decide.',
  },
]

export const bonuses = [
  {
    title: 'BONO 1 — MANUAL DE DIAGNÓSTICO RÁPIDO DE FALLAS™',
    shortTitle: 'Manual de Diagnóstico Rápido de Fallas™',
    desc: 'Utiliza preguntas, árboles de decisión y fichas de diagnóstico para aprender a pasar de un síntoma a posibles causas mediante razonamiento y evidencia.',
    tag: 'Observa. Analiza. Comprueba.',
    value: '$7.990',
  },
  {
    title: 'BONO 2 — KIT DE CHECKLISTS DEL ELECTRICISTA ORGANIZADO™',
    shortTitle: 'Kit de Checklists del Electricista Organizado™',
    desc: 'Checklists para organizar herramientas, inspecciones, mediciones, materiales, diagnóstico y cierre.',
    tag: 'Prepara. Verifica. Registra.',
    value: '$5.990',
  },
  {
    title: 'BONO 3 — GUÍA VISUAL DE HERRAMIENTAS, MATERIALES Y COMPONENTES™',
    shortTitle: 'Guía Visual de Herramientas, Materiales y Componentes™',
    desc: 'Una referencia visual para reconocer rápidamente herramientas, instrumentos, conductores, accesorios, componentes y elementos de seguridad.',
    tag: 'Mira. Reconoce. Aprende.',
    value: '$6.990',
  },
  {
    title:
      'BONO 4 — SIMULADOR DE DIAGNÓSTICO: 20 CASOS ELÉCTRICOS PARA RESOLVER™',
    shortTitle: 'Simulador de Diagnóstico: 20 Casos Eléctricos para Resolver™',
    desc: 'Enfréntate a 20 situaciones ficticias donde tendrás que analizar síntomas, detectar riesgos, formular hipótesis y decidir qué evidencia necesitarías para avanzar.',
    tag: 'Piensa. Investiga. Resuelve.',
    value: '$8.990',
  },
  {
    title:
      'BONO 5 — PACK PROFESIONAL PARA INICIAR TU CAMINO COMO ELECTRICISTA™',
    shortTitle: 'Pack Profesional para Iniciar tu Camino como Electricista™',
    desc: 'Plantillas para relevamientos, presupuestos, órdenes de trabajo, materiales, diagnósticos, seguimiento, ingresos, gastos y organización de herramientas.',
    tag: 'Organiza. Documenta. Profesionaliza.',
    value: '$9.990',
  },
]

export const routeSteps = [
  { icon: '⚡', text: 'Empiezas desde cero.' },
  { icon: '📘', text: 'Comprendes los conceptos esenciales.' },
  { icon: '🔧', text: 'Reconoces herramientas y componentes.' },
  { icon: '🏠', text: 'Entiendes la estructura de una instalación.' },
  { icon: '📏', text: 'Aprendes los fundamentos de medición.' },
  { icon: '🔍', text: 'Desarrollas pensamiento de diagnóstico.' },
]

export const includedTomos = [
  'Tomo 1 — Fundamentos de Electricidad y Seguridad™',
  'Tomo 2 — Herramientas, Materiales y Componentes™',
  'Tomo 3 — Anatomía de una Instalación Domiciliaria™',
  'Tomo 4 — Iluminación, Interruptores y Tomacorrientes™',
  'Tomo 5 — Mediciones y Multímetro™',
  'Tomo 6 — Diagnóstico de Fallas y Método Profesional™',
]

export const offerHighlights = [
  'Diagramas y Ejercicios',
  'Herramientas y Componentes',
  'Multímetro y Mediciones',
  'Casos de Diagnóstico',
  'Recursos de Organización',
  'Acceso Digital Inmediato',
]

export const testimonials = [
  {
    name: 'Diego Fernández',
    role: 'Ayudante de obra, 27 años',
    place: 'Rosario, Argentina',
    text: 'Yo tenía 40 videos guardados y seguía sin saber qué estudiar primero. Con los tomos ordenados entendí de una vez qué es tensión, qué es resistencia y por qué salta el térmico. En la obra ahora entiendo lo que me explica el oficial en lugar de asentir sin saber.',
  },
  {
    name: 'Marcelo Ibáñez',
    role: 'Operario de mantenimiento, 41 años',
    place: 'Córdoba, Argentina',
    text: 'Lo que más me sirvió fue el Tomo 5. Tenía un multímetro guardado en el cajón y no lo usaba por miedo a hacer algo mal. Ahora entiendo qué mido, para qué lo mido y cómo leer el resultado como evidencia y no como adivinanza.',
  },
  {
    name: 'Laura Quiroga',
    role: 'Encargada de edificio, 35 años',
    place: 'Montevideo, Uruguay',
    text: 'Necesitaba entender la instalación del edificio para saber cuándo llamar al electricista y cuándo no. El Tomo 3 me explicó el recorrido completo: alimentación, tablero, protecciones y circuitos. Hoy puedo describir un problema con criterio.',
  },
  {
    name: 'Cristian Molina',
    role: 'Emprendedor, 32 años',
    place: 'Santiago, Chile',
    text: 'Compré buscando un oficio con salida y encontré una ruta real. Los 20 casos del simulador me obligaron a pensar antes de tocar: síntoma, riesgo, hipótesis, evidencia. Ese método me cambió la cabeza más que cualquier tutorial suelto.',
  },
  {
    name: 'Héctor Ramírez',
    role: 'Electricista en formación, 48 años',
    place: 'Guadalajara, México',
    text: 'A mi edad pensé que ya era tarde para ordenar lo que sabía a medias. Los diagramas y los checklists me dieron estructura y las plantillas del Bono 5 me sirvieron para presupuestar mis primeros trabajos con seriedad.',
  },
]

export const faqs = [
  {
    q: '¿Es un producto físico?',
    a: 'No. Es un producto educativo 100% digital con acceso después de la compra.',
  },
  {
    q: '¿Para quién es?',
    a: 'Para principiantes y personas que desean construir una base inicial en electricidad domiciliaria siguiendo una ruta estructurada.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El recorrido comienza desde los fundamentos.',
  },
  {
    q: '¿Voy a aprender a usar un multímetro?',
    a: 'Aprenderás sus funciones principales, conceptos de tensión, resistencia y continuidad, interpretación de resultados y prácticas educativas seguras.',
  },
  {
    q: '¿Incluye ejercicios prácticos?',
    a: 'Sí. Encontrarás ejercicios, diagramas, actividades, casos ficticios, checklists y herramientas para reforzar lo aprendido.',
  },
  {
    q: '¿Los 5 bonos tienen un costo adicional?',
    a: 'No. Los 5 bonos, con un valor de referencia conjunto de $39.950, están incluidos gratis con tu compra durante esta oferta.',
  },
  {
    q: '¿Cuánto cuesta el sistema completo?',
    a: 'El precio especial indicado para esta oferta es de $19.990 en un único pago.',
  },
  {
    q: '¿Es una certificación o me habilita para trabajar profesionalmente?',
    a: 'No. El sistema tiene finalidad educativa. No sustituye formación práctica supervisada, certificaciones, matrículas, licencias ni habilitaciones exigidas en tu jurisdicción.',
  },
  {
    q: '¿El contenido sirve para cualquier país?',
    a: 'Los fundamentos eléctricos son ampliamente aplicables, pero tensiones, colores, protecciones, procedimientos y normativa pueden variar. Debes consultar siempre los requisitos vigentes de tu ubicación.',
  },
  {
    q: '¿Cómo recibiré el producto?',
    a: 'Obtendrás acceso digital después de completar tu compra.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes contactar a CM DIGITAL PRO en soportescmdigital@gmail.com.',
  },
]

export const purchaseAlerts = [
  { name: 'James Whitmore', city: 'Manchester', country: 'Reino Unido' },
  { name: 'Ryan Callaghan', city: 'Toronto', country: 'Canadá' },
  { name: 'Michael Turner', city: 'Phoenix', country: 'Estados Unidos' },
  { name: 'Liam Bradshaw', city: 'Brisbane', country: 'Australia' },
  { name: 'Ethan Reid', city: 'Glasgow', country: 'Reino Unido' },
  { name: 'Noah Kowalski', city: 'Calgary', country: 'Canadá' },
  { name: 'Daniel Foster', city: 'Austin', country: 'Estados Unidos' },
  { name: 'Jack Hollis', city: 'Perth', country: 'Australia' },
  { name: 'Owen Fletcher', city: 'Birmingham', country: 'Reino Unido' },
  { name: 'Lucas Trembley', city: 'Vancouver', country: 'Canadá' },
  { name: 'Brandon Miller', city: 'Denver', country: 'Estados Unidos' },
  { name: 'Cody Sherwood', city: 'Melbourne', country: 'Australia' },
]
